import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
// import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl} from'../Config/Config';


import { useParams, useNavigate} from 'react-router-dom';
const withRouter = WrappedComponent => props => {
  const params = useParams();
  const  navigate = useNavigate();
  return (
	<WrappedComponent
	{...props}
	params={params}
	navigate ={navigate}
	/>
  );
};

class Edit extends Component {
	constructor(props)
	{
		super(props);	
		var RolesId = (typeof this.props.params.ID === 'undefined') ? '' :this.props.params.ID;
		this.state = {
			rolesId:RolesId,
			fname:'',
			lname:'',
			email:'',
			contact:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
            selectedRole:{},
			selectedRolevalue:'',
            selectedMenu:{},
			selectedMenuvalue:'',
            modulelist:'',
            rolelist:'',
			checkedState:'',
			shulelist:'',
			selectedshule:{value:'',label:'Select Shule'},
			selectedshulevalue:'',
		};
		

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var postobject = {
		activePage: 1,
		search_all: '',
		admin_id: admin_id,
      };  
      axios.post(apiUrl+"rolesmanagement/getactiveuserrole",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){         
            this.setState({  rolelist: res.data.rolename, modulelist: res.data.modulelist});  
        }
      }); 



	  var qs = require('qs');
		var rolesId = this.state.rolesId;
		axios.get(apiUrl+"Rolesmanagement/getroledetail?id="+rolesId).then(res => {
			this.setState({
				contact:res.data.list.contact,
				email:res.data.list.email,
				fname:res.data.list.first_name,
				lname:res.data.list.team_name,
				selectedRole:{label:res.data.list.role_name,value:res.data.list.roles},
				selectedRolevalue:res.data.list.roles,
				selectedMenuvalue:res.data.checkmodules,
				checkedState:res.data.checkmodules,
				selectedMenu:res.data.list.admin_allowed_modules,
				selectedshulevalue:res.data.list.shules_id,
			});
			if(res.data.list.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
		}); 

		
		var postobject1 = {
		
			admin_id: admin_id,
			};  
		  axios.post(apiUrl+"rolesmanagement/getactiveshule",qs.stringify(postobject1)).then(res => {
			if(res.data.status === 'success'){         
				this.setState({  shulelist: res.data.shulelist},()=>{
	
					const eventdata = this.state.shulelist.map((shule, Index) => {
						if(this.state.selectedshulevalue == shule.value)
						{
							return shule;
						}
					});
					this.setState({  selectedshule: eventdata});
					
	
				});  
			}
		  }); 
		

   	}

	handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
    handleChangeRole = selectedRole => {
        this.setState({selectedRole})
        this.setState({  selectedRolevalue : selectedRole.value});
		if(selectedRole.admin_allowed_modules!=null&&selectedRole.admin_allowed_modules!='')
		{
			this.setState({  checkedState : selectedRole.admin_allowed_modules.split(',')});		
		}else{
			this.setState({  checkedState :''});
		}
    };

    handleChangeMenu = (selOption) => {
	let modules = [];
	let selValue = [];
	if(selOption!== null){
		selOption.map(item => {
			selValue.push(item.value);
			modules.push({ label: item.label, value: item.value });
		});
		this.setState({selectedMenu:modules});
		this.setState({  selectedMenuvalue : selValue});
	}else{
		this.setState({selectedMenu:''});
		this.setState({  selectedMenuvalue : ''});
	}
	
	

 };

   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
    }
	handleChangeshule = selectedshule => {
        this.setState({selectedshule})
        this.setState({  selectedshulevalue : selectedshule.value});
		  
    };
  
    handleSubmit = () => {
	if(this.validateForm()){
		const formdata = this.state;
		var qs = require('qs');
		var status = '';
		const config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
		if(formdata.selectedvalue === ''){
		status =formdata.selectedOption.value;
		}else{
		status = formdata.selectedvalue;
		}
        
		var postObject ={
            editid:this.state.rolesId,
			admin_id: localStorage.getItem('admin_id'),
			firstname : formdata.fname,
			email : formdata.email,
			contact : formdata.contact,
			status: status,
			role_id: formdata.selectedRole.value,
            role: formdata.selectedRole.label,
			selected_module: formdata.checkedState,
			team_name : formdata.lname,
			shule_id: formdata.selectedshulevalue,
		}	
		axios.post(apiUrl+"Rolesmanagement/addroles",qs.stringify(postObject)).then(res => {
			if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.navigate('/shulerolemanagement'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});
		}
	}

	validateForm() {
		const {fname,lname,email,selectedRolevalue,checkedState,selectedshulevalue} = this.state;
	
		let errors = {};
		  let formIsValid = true;
	
		
		  

		if(!fname){
			formIsValid = false;
			$('.error_fname').html('<span class="errorspan">Please fill the field</span>');
		}else{
			$('.error_fname').html('');
		}	

		if(!lname){
			formIsValid = false;
			$('.error_lname').html('<span class="errorspan">Please fill the field</span>');
		}else{
			$('.error_lname').html('');
		}	
		
		if(!selectedshulevalue){
			formIsValid = false;
			$('.error_shule').html('<span class="errorspan">Please select the field</span>');
		}else{
			$('.error_shule').html('');
		}

        
        if(!selectedRolevalue){
			formIsValid = false;
			$('.error_role').html('<span class="errorspan">Please select the field</span>');
		}else{
			$('.error_role').html('');
		}	

        if(checkedState.length<1){
			formIsValid = false;
			
			$('.error_menu').html('<span class="errorspan">Please select the field</span>');
		}else{
			
			$('.error_menu').html('');
		}
        if (!email) {
	    	formIsValid = false;		
			$('.error_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(email){
			var reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		    // var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		    if (reg.test(email) == false) 
	        {
				formIsValid = false;			
	            $('.error_email').html('<span class="errorspan">Please enter valid email address</span>');
	        }else{
	        	$('.error_email').html('');
	        }
		}

        this.setState({
			errors: errors
		});
		return formIsValid;
	}
	handleOnChange = (i,event) => {
        var id = event.target.value;
        var idArr = [...this.state.checkedState];  
        const index = idArr.findIndex(list => list === id);
        if(index > -1) {
        	idArr = [...idArr.slice(0, index), ...idArr.slice(index + 1)]
			
        } else {			
			idArr.push(id);
        }     
        this.setState({checkedState: idArr});
    };

  render() {
	const {selectedOption,selectedRole,selectedMenu,selectedshule} = this.state;
    return (
      <div className="wrapper"> 
 
	  <Header />
      <MenuSidebar currentpage="shulerolemanagement" />  

	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/shulerolemanagement">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Edit Shules Team</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">					
					<label>Shule <span class="required" style={{ color: "red" }} > * </span> :</label>
                    
					 <Select 
                        name="role"
                        value={selectedshule?selectedshule:{ value: '', label: 'Select Shule'}}
                        options={this.state.shulelist} 
                        isSearchable = {false}
                        onChange={this.handleChangeshule.bind(this)}
                    />

                    <div className="error_shule"></div>
	           </div> 

				<div className="form-group">
					<label>First Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="fname" onChange={this.handleInputChange} className="form-control" value={this.state.fname}/>
					<div className="error_fname"></div>
				</div>
                {/* <div className="form-group">
					<label>Last Name :</label>
				    <input type="text" name="lname" onChange={this.handleInputChange} className="form-control" value={this.state.lname}/>
				</div> */}
                <div className="form-group">					
					<label>Role <span class="required" style={{ color: "red" }} > * </span> :</label>
                    <Select 
                        name="role"
                        value={selectedRole?selectedRole:{ value: 'active', label: 'Active'}}
                        options={this.state.rolelist} 
                        isSearchable = {false}
                        onChange={this.handleChangeRole}
                    />
                    <div className="error_role"></div>
	           </div> 
			   <div className="form-group mt-5">
				   		<h2>Modules Permission <span class="required" style={{ color: "red" }} > * </span>:</h2>
						{this.state.modulelist && Object.keys(this.state.modulelist).length > 0 && this.state.modulelist.map(({label, value}, index) => {
						return (<> 
							<div className="custom_checkbox d-flex align-items-center">
							<input
							type="checkbox"
							id={`custom-checkbox-${index}`}
							name={label}
							value={value}
							checked={this.state.checkedState.includes(value)}
							onChange={this.handleOnChange.bind(this,index)}
							/>
							<span></span>
							<label htmlFor={`custom-checkbox-${index}`}>{label}</label>
							</div>
						</>)})}	
						<div className="error_menu"></div>
					</div>	
              
				
			</div>
                  
			<div className="form-right">
				<div className="form-group">
					<label>Team Name <span class="required" style={{ color: "red" }} > * </span>:</label>
				    <input type="text" name="lname" onChange={this.handleInputChange} className="form-control" value={this.state.lname}/>
					<div className="error_lname"></div>
				</div>
                <div className="form-group">
					<label>Email<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="email" name="email" onChange={this.handleInputChange} className="form-control" value={this.state.email}/>
					<div className="error_email"></div>
				</div>
                <div className="form-group">
					<label>Contact :</label>
				    <input type="number" name="contact" onChange={this.handleInputChange} className="form-control" value={this.state.contact}/>
				</div>
                {/* <div className="form-group">					
					<label>Module <span class="required" style={{ color: "red" }} > * </span> :</label>
                    <Select 
                        name="menu"
                        value={selectedMenu?selectedMenu:{ value: 'active', label: 'Active'}}
                        options={this.state.modulelist} 
                        isSearchable = {true}
                        onChange={this.handleChangeMenu}
                        isMulti
                    />
                    <div className="error_menu"></div>
	           </div>  */}

				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
                    <Select 
                        name="status"
                        value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                        options={lang.common.status_option} 
                        isSearchable = {false}
                        onChange={this.handleChange}
                    />
	           </div> 
				

			</div>	
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >
									
					Submit
			   </button>
			 
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Edit));